import { X } from "lucide-react";

const colors = {
    success: "bg-lime-600",
    error: "bg-red-600",
    info: "bg-blue-600",
    warning: "bg-yellow-600",
};

export default function NotificationList({ notifications, removeNotification }) {
    return (
        <div className="fixed top-5 right-5 z-50 flex flex-col gap-3">
            {notifications.map((n) => (
                <div
                    key={n.id}
                    className={`text-white px-4 py-3 rounded-xl shadow-lg flex items-center justify-between min-w-[250px] ${colors[n.type]}`}
                >
                    <span className="text-sm text-white">{n.message}</span>

                    <X
                        className="w-4 h-4 cursor-pointer opacity-70 hover:opacity-100"
                        onClick={() => removeNotification(n.id)}
                    />
                </div>
            ))}
        </div>
    );
}
